<template>
<button :class="_class" @click="$emit('click')">
    <slot></slot>
</button>
</template>

<script>
export default {
    props: {
        size: [String],
        variant: {
            default: 'default'
        },
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('btn')
            _class.push('btn-'+this.variant)

            if(this.size) {
                _class.push('btn-size')
            }

            return _class
        }
    }
}
</script>